module.exports = __webpack_public_path__ + "static/media/crown.71a0bf2f.png";